import { fork } from "typed-redux-saga";

import { menuServiceSaga } from "./menuServiceSaga";

export function* menuRootSaga() {
    // Starts the menus service saga, responsible for fetching and updating the menu.
    yield* fork(menuServiceSaga);
}
